import React from "react"

export default function Blog025() {
  return (
    <section>
    <article>
    <h2>25. 11-17-2022</h2>
          <h3>NEXTjs</h3>
          <p>
          <strong>Hello!</strong>
          <br /><br />
          My name is Eric Polley. I am a developer at ericpolley.com <br />
          As the title may imply I have been working with NextJS. 
          My goal is to utilize NextJS to build a shop with a cart, checkout, and proper authentication. <br />
          I am using a Udemy course 'Nextjs by Example' to build a website with static props. I successfully created a shop website 
          front pulling information from the Strapi API to create a list of products. The list of products are linked 
          to the product id and display a web page with the corresponding information. <br />
          I enjoyed creating the website so far, but I would like to explore my options. <br />
          I discovered a tutorial on Egghead.io 'Create a New Next.js App for an Online Store'. <br />
          This tutorial uses NextJS, SnipCart, and GraphQL. I am working on this tutorial currently. <br />
          This is a large amount of learning, but when I am done I will build a e-commerce website from scratch 
          and attach it to my portfolio website. The link to my website is below, in the Links section.  

         
          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
        
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
